import { render } from "./EditMetricValues.vue?vue&type=template&id=1164889a&scoped=true"
import script from "./EditMetricValues.vue?vue&type=script&lang=js"
export * from "./EditMetricValues.vue?vue&type=script&lang=js"

import "./EditMetricValues.vue?vue&type=style&index=0&id=1164889a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1164889a"]])

export default __exports__